import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconHomeDoor"><Path d="M12.4749 1.41953C12.1987 1.19349 11.8013 1.19349 11.5251 1.41953L3.27507 8.16953C3.10097 8.31198 3 8.52505 3 8.75V20.25C3 20.4489 3.07902 20.6397 3.21967 20.7803C3.36032 20.921 3.55109 21 3.75 21H8V12.75C8 12.3358 8.33579 12 8.75 12H15.25C15.6642 12 16 12.3358 16 12.75V21H20.25C20.6642 21 21 20.6642 21 20.25V8.75C21 8.52505 20.899 8.31198 20.7249 8.16953L12.4749 1.41953Z" fill="currentColor"/><Path d="M14.5 21V13.5H9.5V21H14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeDoor;
